export default __webpack_public_path__ + "static/media/ID2254423.75d96e8e.png";